import { Connection } from 'utils';
import { GET_AFFILIATES_BY_HIERARCHIES } from 'constants/api';

const getAffiliatesByHierarchies = filter => Connection.post(GET_AFFILIATES_BY_HIERARCHIES, filter);

export default {
  getAffiliatesByHierarchies,
};
